class ApiValidationError extends Error {
    constructor(message, errors, statusCode) {
        super(message);
        this.name = 'ApiValidationError';
        this.statusCode = statusCode;
        this.errors = errors;
    }
}

export default ApiValidationError;
